/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface AccessRolePresetsDestroy$Params {
  pid: number;
}

export function accessRolePresetsDestroy(
  http: HttpClient,
  rootUrl: string,
  params: AccessRolePresetsDestroy$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, accessRolePresetsDestroy.PATH, 'delete');
  if (params) {
    rb.path('pid', params.pid, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

accessRolePresetsDestroy.PATH = '/api/access/role-presets/{pid}/';
